import { NgModule } from '@angular/core';

import { CronacaComponent } from './cronaca.component';
import { SharedModule } from '../shared/shared.module'

@NgModule({
    imports: [SharedModule],
    declarations: [CronacaComponent],
    exports: [CronacaComponent],
    providers: []
})
export class CronacaModule { }


// WEBPACK FOOTER //
// ./src/app/cronaca/cronaca.module.ts